import React from 'react';
import { connect } from 'react-redux';

import DashboardCard from '@modules/common/components/DashboardCard';
import { StoreState } from '@src/meta/types/store';
import { CustomerAccountInfo } from '@modules/auth/components/types/customer-account';
import { ServerProjectInfo } from '@modules/auth/components/types/project';

import ExistingClients from './ExistingClients';

type PropsFromStore = {
  account?: CustomerAccountInfo;
  project?: ServerProjectInfo;
};

function OAuthClients({ account, project }: PropsFromStore) {
  if (!account || !project) {
    return null;
  }
  return (
    <DashboardCard style={{ marginTop: '20px', minHeight: '470px' }} height="auto">
      <ExistingClients ownerId={project.id} limit={account.oauthClientLimitN} />
    </DashboardCard>
  );
}

const mapStateToProps = (state: StoreState): PropsFromStore => ({
  account: state.account.account,
  project: state.project.project,
});

export default connect(mapStateToProps)(OAuthClients);
